import React, { useContext, useEffect, useState } from "react";
import logo from "../Images/only_logo.png";
import text from "../Images/only_slogan.png";
import MenuItem from "./MenuItem";
// import { AiOutlineLeftCircle, AiOutlineRightCircle, AiOutlineBarChart } from "react-icons/ai"
import {
  MdOutlineFormatIndentDecrease,
  MdOutlineFormatIndentIncrease,
} from "react-icons/md";
// import { claim } from "../Auth/auth.model.d";
// import jwtDecode from "jwt-decode";
import * as RiIcons from "react-icons/ri";
// import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
// import { getToken } from "../Auth/HandleJWT";
import { Link, NavLink } from "react-router-dom";
import getRole from "../Auth/GetRole";
import authHeader from "../Auth/authHeader";
import FiscalYearSelector from "../FiscalYear/FiscalYearSelector";
import { FiscalYearContext } from "../FiscalYear/FiscalYearContext";
import { updateAlert } from "../Components/Alerts";
import PropTypes from "prop-types";
import getCompanyPack from "../Auth/GetCompanyPack";

export const menuItems = [
  {
    name: "Paneli",
    exact: true,
    to: "#",
    to: "/dashboard",
    role: "admin",
    iconClassName: "bi bi-speedometer",
  },
];
export const menuItemss = [
  {
    name: "Paneli",
    exact: true,
    to: "/dashboard",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-speedometer",
  },
  {
    // name: "Articles",
    name: "Artikujt",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-upc-scan",
    subMenus: [
      {
        name: "Lista Artikujve",
        to: "/articles/articleslist",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
        iconClassName: "bi bi-list-ul",
        // role: "admin",
      },
      {
        // name: "Groups",
        name: "Grupet",
        to: "/articles/articlegroups",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
        iconClassName: "bi bi-collection",
        // role: "staf",
      },
      {
        // name: "Units",
        name: "Njësitë",
        to: "/articles/articleunits",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
        iconClassName: "bi bi-rulers",
        // role: "staf",
      },
    ],
  },

  {
    // name: "Accounts",
    name: "Llogaritë",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-person-lines-fill",
    subMenus: [
      {
        // name: "Clients",
        name: "Klientët",
        to: "/accounts/clients",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Clients",
        name: "Njësit e klientëve",
        to: "/accounts/clientUnits",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Suppliers",
        name: "Furnitorët",
        to: "/accounts/suppliers",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Cash Registers",
        name: "Arkat",
        to: "/accounts/cashregisters",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Banks",
        name: "Bankat",
        to: "/accounts/banks",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Owners",
        name: "Pronarët",
        to: "/accounts/owners",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Employees",
        name: "Punonjësit",
        to: "/accounts/employees",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "The tenants",
        name: "Qiradhënësit",
        to: "/accounts/thetenants",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      // {
      //   // name: "Expences Category",
      //   name: "Klasifikimi Shpënzimeve",
      //   to: "/accounts/expences",
      //   pack: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond'],
      // },
      // {
      //   // name: "Long Term Assets",
      //   name: "Asetet",
      //   to: "/accounts/longtermassets",
      //   pack: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond'],
      // },
      {
        // name: "Others",
        name: "Llogari Tjera",
        to: "/accounts/others",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },

  // "mulliri" === "mulliri" ?
  {
    name: "Blerjet",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-bag-check-fill",
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subMenus: [
      {
        name: "Blerjet Detale",
        to: "/purchases/detailpurchase",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Blerjet Totale",
        to: "/purchases/purchaseintotal",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Importet",
        to: "/purchases/import",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Blerjet Detale nga fermeret",
        to: "/purchases/FarmerPurchase",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },
  // :
  //   {
  //   name: "Blerjet",
  //   exact: true,
  //   to: "#",
  //   role: ['acctree', 'admin', 'adminunit', 'staff'],
  //   pack: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond'],
  //   iconClassName: "bi bi-bag-check-fill",
  //   iconOpened: <RiIcons.RiArrowUpSFill />,
  //   subMenus: [
  //     {
  //       name: "Blerjet Detale",
  //       to: "/purchases/detailpurchase",
  //       pack: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond'],
  //     },
  //     {
  //       name: "Blerjet Totale",
  //       to: "/purchases/purchaseintotal",
  //       pack: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond'],
  //     },
  //     {
  //       name: "Importet",
  //       to: "/purchases/import",
  //       pack: ['Gold', 'Platinum', 'Diamond'],
  //     },
  //   ]
  // },

  {
    name: "Blerjet Investive",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-building",
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subMenus: [
      {
        name: "Blerjet Investive Total",
        to: "/purchases/investmentpurchases",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Asetet",
        to: "/accounts/longtermassets",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      // {
      //   name: "Zhvlersimi",
      //   to: "#",
      //   pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      // },
      {
        name: "Importi Investiv",
        to: "/purchases/investmentImport",
        pack: ["Gold", "Platinum", "Diamond"],
      },
    ],
  },

  {
    // name: "Expences",
    name: "Shpenzimet",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-subtract  ",
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subMenus: [
      {
        name: "Klasifikimi Shpënzimeve",
        to: "/accounts/expences",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Shpenzimet",
        to: "/expences/expensepurchases",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Qiraja",
        to: "/expences/rent",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Pagat",
        to: "/expences/wages",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Interesi/Provizioni",
        to: "/expences/interes",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },
  ///////////////////////////////////////////////////////////////////
  {
    name: "Shitjet",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-cart-check-fill",
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subMenus: [
      {
        // name: "Sales in details",
        name: "Shitjet Detale",
        to: "/Sales/salesindetails",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "P.O.S.",
        to: "/Sales/pos",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Sales in total",
        name: "Shitjet Totale",
        to: "/Sales/salesintotal",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Advance",
        name: "Avancet",
        to: "/Sales/advance",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Sale with Z-Raport",
        name: "Shitjet me Z-Raport",
        to: "/Sales/Z-salesdetail",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Pro Faturat",
        to: "/Sales/proInvoice",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Ofertat",
        to: "/Sales/offer",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },

  ///////////////////////////////////////////////////////
  {
    name: "Debit & Kredit Nota",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-stickies-fill",
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subMenus: [
      {
        name: "Notat Debitore",
        to: "/Sales/debitnote",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Notat Kreditore",
        to: "/Sales/creditnote",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Kthimi I Mallit nga Klienti",
        to: "/Sales/returnFromCustomer",
        pack: ["Silver","Gold", "Platinum", "Diamond"],
      },
      {
        name: "Kthimi I Mallit tek Furnitori",
        to: "/Sales/returnToSupplier",
        pack: ["Silver","Gold", "Platinum", "Diamond"],
      },
    ],
  },
  //////////////////////////////////////////////////////////////////
  {
    name: "Kontabiliteti",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-stack",
    subMenus: [
      {
        name: "Fletat Kontabël",
        to: "/accounting/accountingsheets",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Fletë Hyrjet",
        to: "/accounting/entrysheet",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Fletë Daljet",
        to: "/accounting/exitsheet",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Kopërtinat",
        to: "/configuration/coverpage",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      // {
      //   name: "Kapitujt e Folderave",
      //   to: "/configuration/folders",
      //   pack: ['Bronze', 'Silver'],
      // },
    ],
  },
  ////////////////////////////////////////////////////////////////////
  {
    name: "Paraja",
    exact: true,
    role: ["acctree", "admin", "adminunit", "staff"],
    to: "#",
    pack: ["Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-cash-coin",
    subMenus: [
      {
        // name: "Receivables",
        name: "Arkëtimet",
        to: "/money/receivables",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Payments",
        name: "Pagesat",
        to: "/money/payments",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Withdrawal",
        name: "Tërheqjet",
        to: "/money/withdrawal",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Transfers",
        name: "Transferet/Urdhëresat",
        to: "/money/transfers",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Transfers",
        name: "Deponimi i Kapitalit",
        to: "/money/capitalDeposit",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },
  ////////////////////////////////////////////////////////////////////
  {
    name: "Prodhimi",
    exact: true,
    role: ["acctree", "admin", "adminunit", "staff"],
    to: "#",
    pack: ["Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-box-seam",
    subMenus: [
      {
        name: "Artikulli i përbërë",
        to: "/produc/compoundArticle",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Normativi",
        to: "/produc/normativ",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Prodhimi",
        to: "/produc/produce",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },

  ////////////////////////////////////////////////////////////////////
  {
    // name: "Accounting Books",
    name: "Librat Kontabël",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-book-half",
    subMenus: [
      {
        // name: "Sales Book",
        name: "Librat e Shitjës",
        to: "/accounting/salesbook",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Purchase Book",
        name: "Librat e Blerjës",
        to: "/accounting/purchasebook",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Expences Book",
        name: "Librat e Shpënzimeve",
        to: "/accounting/expencebook",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Investments Book",
        name: "Librat e Bl. Investive",
        to: "/accounting/investmentbook",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },
  {
    name: "Raportet e Tatimeve",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit"],
    pack: ["Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-circle-half",
    subMenus: [
      {
        name: "Librat e Shitjeve - ATK",
        to: "/tax/salesbook",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Librat e Blerjeve - ATK",
        to: "/tax/purchasebook",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Deklarata e TVSH-së",
        to: "/tax/vatdeclaration",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Raport Vjetor i TVSH-së",
        to: "/tax/vat-monthly-synthetic",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Deklarata Vjetore - ATK",
        to: "/tax/annualdeclaration",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Deklarata WM CM - ATK",
        to: "/tax/taxwagesreport",
        pack: ["Silver", "Gold", "Platinum", "Diamond"],
      },
      // {
      //   name: "Statement Of Changes In Equity",
      //   to: "/tax/changesInEquity",
      //   pack: ['Silver', 'Gold', 'Platinum', 'Diamond']
      // },
    ],
  },

  {
    // name: "Accounting Reports",
    name: "Raportet Kontabel",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-bar-chart-line-fill",
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subMenus: [
      //Journal History
      {
        // name: "Journal History",
        name: "Ditari i Transaksioneve",
        to: "/accounting/journalhistory",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Inventory",
        name: "Stoku në detale",
        to: "/accounting/inventory",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      //furnitori
      {
        // name: "Accounts Payable",
        name: "Llogaritë e Pagueshme",
        to: "/Reports/accountspayable",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      //klienti
      {
        // name: "Accounts Receivable",
        name: "Llogaritë e Arkëtueshme",
        to: "/Reports/accountsreceivable",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Accounts Partners AR/AP",
        name: "Llogaritë e Partnerëve",
        to: "/Reports/accountspartners",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Accounts Receivable",
        name: "Llogaritë e Pagave",
        to: "/Reports/wagesAccount",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Accounts Receivable",
        name: "Llogaritë e Qirasë",
        to: "/Reports/rentAccounts",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      //BANKA
      {
        // name: "Money In Banks",
        name: "Paraja në Bankë",
        to: "/Reports/moneybank",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      //arka
      {
        // name: "Money In CASH",
        name: "Paraja në Arkë",
        to: "/Reports/cashmoney",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Raporti i Prodhimit",
        to: "/Reports/production-report",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },
  {
    name: "Kartelat",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit"],
    pack: ["Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-card-list",
    subMenus: [
      {
        name: "Kartela Artikullit",
        to: "/card/articlesCard",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Kartela Klientit",
        to: "/card/clientCard",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Kartela Furnitorit",
        to: "/card/supplierCard",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Kartela e Agjentit",
        to: "/card/agentCard",
        pack: ["Gold", "Platinum", "Diamond"],
      },
    ],
  },
  {
    name: "Pasqyrat Financiare",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-currency-exchange",
    subMenus: [
      {
        name: "Bilanci i Gjendjës",
        to: "/financestatements/balancesheet",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Pasqyra e të Ardhurave",
        to: "/financestatements/incomestatements",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Pasqyra e rrjedhës së parasë",
        to: "/financestatements/cashflow",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Pasqyra e ndryshimeve në ekuitet",
        to: "/financestatements/equitychanges",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Shpalosjet e Pasqyrave Financiare",
        to: "/financestatements/notes",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Bilanci Vërtetues",
        to: "/financestatements/TrialBalance",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      // {
      //   name: "Raporti i shitjeve mujore",
      //   to: "/financestatements/MonthlySalesReport",
      //   pack: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond']
      // },
      // {
      //   name: "Raporti i blerjeve mujore",
      //   to: "/financestatements/MonthlyPurchaseReport",
      //   pack: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond']
      // },
      // {
      //   name: "Raporti i shpenzimeve mujore",
      //   to: "/financestatements/MonthlyExpenseReport",
      //   pack: ['Gold', 'Platinum', 'Diamond']
      // },
      // {
      //   name: "Raporti mujor i pagave",
      //   to: "/financestatements/MonthlyWagesReport",
      //   pack: ['Gold', 'Platinum', 'Diamond']
      // },
      // {
      //   name: "Raporti mujor i qirasë",
      //   to: "/financestatements/MonthlyRentReport",
      //   pack: ['Gold', 'Platinum', 'Diamond']
      // },
      // {
      //   name: "Raporti i klasifikimit të Shpenzimeve",
      //   to: "/financestatements/MonthlyExpenseClassReport",
      //   pack: ['Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond']
      // },
      // {
      //   name: "Raporti mujor i interesit",
      //   to: "/financestatements/MonthlyInterestReport",
      //   pack: ['Gold', 'Platinum', 'Diamond'],
      // },
      // {
      //   name: "Mjetet themelore",
      //   to: "/financestatements/fixedAssetReport",
      //   pack: ['Gold', 'Platinum', 'Diamond'],
      // },
    ],
  },
  {
    name: "Shpalosjet",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit"],
    pack: ["Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-file-earmark-ruled",
    subMenus: [
      {
        name: "Raporti i shitjeve mujore",
        to: "/financestatements/MonthlySalesReport",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Raporti i blerjeve mujore",
        to: "/financestatements/MonthlyPurchaseReport",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Raporti i shpenzimeve mujore",
        to: "/financestatements/MonthlyExpenseReport",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Raporti mujor i pagave",
        to: "/financestatements/MonthlyWagesReport",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Raporti mujor i qirasë",
        to: "/financestatements/MonthlyRentReport",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Raporti i klasifikimit të Shpenzimeve",
        to: "/financestatements/MonthlyExpenseClassReport",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Raporti mujor i interesit",
        to: "/financestatements/MonthlyInterestReport",
        pack: ["Gold", "Platinum", "Diamond"],
      },
      {
        name: "Mjetet themelore",
        to: "/financestatements/fixedAssetReport",
        pack: ["Gold", "Platinum", "Diamond"],
      },
    ],
  },
  {
    name: "Fillo Vitin Fiskal",
    exact: true,
    to: "#",
    role: ["acctree", "admin", "adminunit"],
    pack: ["Gold", "Platinum", "Diamond"],
    iconClassName: "bi bi-sliders",
    subMenus: [
      {
        name: "Bartja e Llogarive Kontabel",
        to: "/newFiscalYear/transferAccounts",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Bartja e Stokut Fillestar",
        to: "/newFiscalYear/stockTransfer",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },
  {
    name: "Konfigurimet",
    exact: true,
    to: "#",
    iconClassName: "bi bi-gear-wide-connected",
    role: ["acctree", "admin", "adminunit", "staff"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    subMenus: [
      {
        // name: "Users",
        name: "Përdoruesit",
        to: "/configuration/users",
        role: "admin",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      // {
      //   // name: "Company",
      //   name: "Kompania",
      //   to: "/configuration/company",
      //   pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      // },
      {
        // name: "Company Units",
        name: "Njësitë Organizative",
        to: "/configuration/companyunits",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Licenced Banks",
        name: "Bankat e Licencuara",
        to: "/configuration/licencedbanks",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },

      {
        // name: "States",
        name: "Shtetet",
        to: "/configuration/states",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Cities",
        name: "Qytet",
        to: "/configuration/cities",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "Ledgers",
        name: "Llogaritë Kontabël",
        to: "/configuration/ledgers",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        // name: "VAT Rates",
        name: "Normat e TVSH-së",
        to: "/configuration/vatrates",
        role: "admin",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },
  {
    name: "Hapje të Llogarive",
    exact: true,
    to: "#",
    iconClassName: "bi bi-gear-wide-connected",
      role: ["acctree"],
    pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
    subMenus: [
      {
        name: "Përdoruesit",
        to: "/configuration/users",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Përdoruesit e Ordinancave",
        to: "/ordinance/users",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Kompania",
        to: "/configuration/company",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
            {
        name: "Licensat",
        to: "/configuration/licenses",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Kërkesat BarTree",
        to: "/configuration/bar-tree-renewals",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Moduli P.O.S",
        to: "/configuration/fiscalCashRegister",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Lista Menuve",
        to: "/configuration/menuItems",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
      {
        name: "Notifikimet",
        to: "/configuration/notification",
        pack: ["Bronze", "Silver", "Gold", "Platinum", "Diamond"],
      },
    ],
  },
];

const SideMenu = (props) => {
  const [inactive, setInactive] = useState(false);
  const [activeSubMenuIndex, setActiveSubMenuIndex] = useState(null);
  const [activeSubMenuItem, setActiveSubMenuItem] = useState(null); // Ruajtja e submenu-it aktiv
  const { fiscalYear } = useContext(FiscalYearContext);
  const currentYear = new Date().getFullYear();
  const [userRole, setUserRole] = useState(null);
  const [pack, setPack] = useState("");
  const headers = authHeader();
  const [isDashboardActive, setIsDashboardActive] = useState(false);

  // const pack = 'Bronze'

  useEffect(() => {
    if (inactive) {
      document.querySelectorAll(".sub-menu").forEach((el) => {
        el.classList.remove("active");
      });
    }
    props.onCollapse(inactive);
  }, [inactive]);

  useEffect(() => {
    getRole(headers).then(setUserRole);
  }, []);

  useEffect(() => {
    getCompanyPack(headers).then(setPack);
  }, []);

  useEffect(() => {
    if (fiscalYear < currentYear) {
      updateAlert(`Kujdes!! Viti Fiskal është ndryshuar ${fiscalYear}`);
    } else {
      // updateAlert(`Keni ndryshuar vitin fiskal:  ${fiscalYear}`);
    }
  }, [fiscalYear, currentYear]);

  return (
    <div
      className={`side-menu ${inactive ? "inactive" : ""}`}
      style={{ width: inactive ? "" : "250px" }}
    >
      <div className="top-section">
        <div
          className="side-menu-header"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <div
            className="logo"
            onClick={() => {
              setIsDashboardActive(true);
            }}
          >
            <Link to="/dashboard">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="header-font">
            <Link
              to="/dashboard"
              onClick={() => {
                setIsDashboardActive(true);
              }}
            >
              <img
                src={text}
                alt="text"
                style={{ width: "60%", marginLeft: "40px", marginTop: "-10px" }}
              />
            </Link>
          </div>
        </div>
        {/* <div onClick={() => setInactive(!inactive)} className="toggle-menu-btn" style={{ marginTop: "10%", border: "solid red 2px" }}>
          {inactive ? <MdOutlineFormatIndentIncrease style={{ marginTop: "50%" }} /> : <MdOutlineFormatIndentDecrease style={{ marginTop: "50%" }} />}
        </div> */}
        <div
          onClick={() => {
            if (inactive) {
              // Kur sidebar hapet, rivendos submenu-n e fundit aktive
              setInactive(false);
            } else {
              // Kur sidebar mbyllet, mbyll submenu-n aktuale
              setInactive(true);
              setActiveSubMenuIndex(null);
            }
          }}
          className="toggle-menu-btn"
          style={{ marginTop: "10%" }}
        >
          {inactive ? (
            <MdOutlineFormatIndentIncrease style={{ marginTop: "50%" }} />
          ) : (
            <MdOutlineFormatIndentDecrease style={{ marginTop: "50%" }} />
          )}
        </div>
      </div>

      <div className="divider"></div>

      <div className="main-menu">
        <ul>
          {menuItems.map((menuItem, index) => {
            return (
              <MenuItem
                key={index}
                {...menuItem}
                bgColor={isDashboardActive ? "#284945" : ""}
                onClick={() => {
                  if (inactive) setInactive(false);
                  setIsDashboardActive(true);
                }}
              />
            );
          })}
          <div className="divider"></div>
          {menuItemss &&
            menuItemss
              .filter((menuItem) => {
                // Kontrolloni nëse paketa e përdoruesit është në `menuItem.pack`
                return menuItem.pack.includes(pack);
              })
              .map((menuItem, index) => {
                if (menuItem.role && menuItem.role.includes(userRole)) {
                  const isSubMenuActive =
                    menuItem.subMenus &&
                    menuItem.subMenus.some(
                      (subMenu) => subMenu.to === activeSubMenuItem,
                    );

                  return (
                    <div key={index}>
                      <MenuItem
                        name={menuItem.name}
                        exact={menuItem.exact}
                        to={menuItem.to}
                        iconClassName={menuItem.iconClassName}
                        bgColor={
                          isDashboardActive
                            ? isSubMenuActive
                              ? ""
                              : ""
                            : isSubMenuActive
                              ? "#284945"
                              : ""
                        }
                        onClick={() => {
                          if (inactive) {
                            setInactive(false);
                          }
                          setActiveSubMenuIndex(
                            activeSubMenuIndex === index ? null : index,
                          );
                        }}
                        style={{
                          borderRadius: "5px",
                          padding: "5px 10px",
                        }}
                      />
                      {menuItem.subMenus && activeSubMenuIndex === index && (
                        <div style={{ paddingLeft: "10px" }}>
                          {menuItem.subMenus
                            .filter((subMenu) => subMenu.pack.includes(pack)) // Filtroni submenus për paketën
                            .map((subMenu, subIndex) => (
                              <div
                                key={subIndex}
                                style={{
                                  backgroundColor:
                                    activeSubMenuItem === subMenu.to
                                      ? "#284945"
                                      : "",
                                  borderRadius:
                                    activeSubMenuItem === subMenu.to
                                      ? "5px"
                                      : "",
                                  marginLeft: "30px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setActiveSubMenuItem(subMenu.to);
                                  setIsDashboardActive(false);
                                }}
                              >
                                <NavLink
                                  to={subMenu.to}
                                  style={{
                                    display: "block",
                                    color: "gray",
                                    textDecoration: "none",
                                    margin: "5px",
                                    position: "relative",
                                    fontSize: "15px",
                                  }}
                                >
                                  <span
                                    style={{
                                      position: "absolute",
                                      left: "-15px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      fontSize: "20px",
                                    }}
                                  >
                                    •
                                  </span>
                                  {subMenu.name}
                                </NavLink>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  );
                }
                return null;
              })}
        </ul>
        <div className="divider"></div>
      </div>
      <div>
        {inactive ? (
          <p style={{ color: "white" }}>{fiscalYear}</p>
        ) : (
          <FiscalYearSelector />
        )}
      </div>

      <div className="side-menu-footer">
        <div className="user-info">
          <p className="email_infoo">
            Copyright © {fiscalYear} acctree | {pack}
          </p>
        </div>
      </div>
    </div>
  );
};

SideMenu.propTypes = {
  onCollapse: PropTypes.func.isRequired,
};

export default SideMenu;
